Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Select panes state for a given namespace.
 */
exports.panesNamespaceSelector = function (state, namespace) { return state[namespace]; };
/**
 * Select current pane in pane collection.
 */
exports.panesNsCurrentPaneSelector = function (panes) { return panes.find(function (pane) { return pane.isCurrent; }); };
/**
 * Select current pane for a given namespace.
 */
exports.panesCurrentPaneSelector = function (state, namespace) {
    var namespaceState = exports.panesNamespaceSelector(state, namespace);
    if (namespaceState === undefined)
        return;
    return exports.panesNsCurrentPaneSelector(namespaceState.panes);
};
/**
 * Select a pane by its id in pane collection.
 */
exports.panesNsPaneSelector = function (panes, paneId) { return panes.find(function (pane) { return pane.id === paneId; }); };
/**
 * Select a pane by its id for a given namespace.
 */
exports.panesPaneSelector = function (state, namespace, paneId) {
    var namespaceState = exports.panesNamespaceSelector(state, namespace);
    if (namespaceState === undefined)
        return;
    return exports.panesNsPaneSelector(namespaceState.panes, paneId);
};
/**
 * Select pane & content for a given content id in pane collection.
 */
exports.panesNsContentSelector = function (panes, contentId) {
    var selection;
    panes.forEach(function (pane) {
        var content = pane.contents.find(function (c) { return c.id === contentId; });
        if (content !== undefined) {
            selection = { pane: pane, content: content };
        }
    });
    return selection;
};
/**
 * Select pane & content for a given content id in a specific namespace.
 */
exports.panesContentSelector = function (state, namespace, contentId) {
    var namespaceState = exports.panesNamespaceSelector(state, namespace);
    if (namespaceState === undefined)
        return;
    return exports.panesNsContentSelector(namespaceState.panes, contentId);
};
/**
 * Select all current contents in pane collection.
 */
exports.panesNsCurrentContentsSelector = function (panes) { return panes.reduce(function (agg, pane) {
    var currentContent = pane.contents.find(function (content) { return content.isCurrent; });
    if (currentContent === undefined)
        return agg;
    var doesExist = agg.find(function (content) { return content.id === currentContent.id; });
    if (doesExist)
        return agg;
    return agg.concat([currentContent]);
}, []); };
/**
 * Select all current contents in a specific namespace.
 */
exports.panesCurrentContentsSelector = function (state, namespace) {
    var namespaceState = exports.panesNamespaceSelector(state, namespace);
    if (namespaceState === undefined)
        return [];
    return exports.panesNsCurrentContentsSelector(namespaceState.panes);
};
